import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import './editors.scss';
import { LL_H_C, LL_H_T, LL_V_L, SimpleListAdapter, TS_DropDown, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { BadImplementationException, exists, MUSTNeverHappenException } from '@nu-art/ts-common';
import { DefaultEditor_InputNumeric } from '@app/styles/frontend/ui-manager/ui-components';
import { ModuleFE_Expression, ModuleFE_Value, ModuleFE_Variable, } from '../../../../../../_entity.js';
import { getAtomQueryFilter, getExpressionQueryFilter, getValueQueryFilter, validateLeftHandBaseExists } from './utils.js';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { QRangeInputV3 } from '../../../../../q-components/QRangeInputV3.js';
import { DropDown_Value } from '../../../../../../_entity/value/ui-components.js';
import { filterRelevantValues } from '../../../../../healthcare-space/variables/components/Component_RelationsTable/utils/utils.js';
import { DropDown_DeltaTypes } from '../../../../../../_entity/expression/ui-components.js';
import { AllDeltaLogic, AllLogics, DeltaTypes, EmptyRightHandOperators, ExpressionOutput_Numeric, getBaseDeltaOperator, getLeftHandType, LogicType_AboveNormal, LogicType_AboveRange, LogicType_BelowNormal, LogicType_BelowRange, LogicType_Delta, LogicType_DeltaEquals, LogicType_DeltaGreaterEquals, LogicType_DeltaGreaterThan, LogicType_DeltaIn, LogicType_DeltaLesserEquals, LogicType_DeltaLesserThan, LogicType_DeltaPercentage, LogicType_DeltaPercentageEquals, LogicType_DeltaPercentageGreaterEquals, LogicType_DeltaPercentageGreaterThan, LogicType_DeltaPercentageIn, LogicType_DeltaPercentageLesserEquals, LogicType_DeltaPercentageLesserThan, LogicType_Equals, LogicType_Exists, LogicType_NotExists, LogicType_GreaterOrEqual, LogicType_GreaterThan, LogicType_In, LogicType_InNormal, LogicType_InRange, LogicType_InSet, LogicType_IsChiefComplaint, LogicType_IsFalse, LogicType_IsTrue, LogicType_LessOrEquals, LogicType_LessThan, LogicType_NotEquals, LogicType_NotInSet, LogicType_Self, resolveValueDisplay, resolveValueType, SelfOperators, valueID_YesNo, valueType_Range, valueType_StandardRange } from '@app/hcs-shared';
export class Editor_Case extends TS_EditableItemComponent {
    Renderers = {
        [LogicType_InSet]: this.renderInSetDropdownList.bind(this),
        [LogicType_NotInSet]: this.renderInSetDropdownList.bind(this),
        [LogicType_In]: this.renderNumericInput.bind(this),
        [LogicType_Self]: () => _jsx(_Fragment, {}),
        [LogicType_InRange]: this.renderFactorInput.bind(this),
        [LogicType_BelowRange]: this.renderFactorInput.bind(this),
        [LogicType_AboveRange]: this.renderFactorInput.bind(this),
        [LogicType_InNormal]: this.renderFactorInput.bind(this),
        [LogicType_BelowNormal]: this.renderFactorInput.bind(this),
        [LogicType_AboveNormal]: this.renderFactorInput.bind(this),
        [LogicType_Equals]: this.renderEqualityByType.bind(this).bind(this),
        [LogicType_NotEquals]: this.renderEqualityByType.bind(this).bind(this),
        [LogicType_LessOrEquals]: this.renderNumericInput.bind(this),
        [LogicType_DeltaGreaterEquals]: this.renderNumericInput.bind(this),
        [LogicType_DeltaGreaterThan]: this.renderNumericInput.bind(this),
        [LogicType_DeltaLesserEquals]: this.renderNumericInput.bind(this),
        [LogicType_DeltaLesserThan]: this.renderNumericInput.bind(this),
        [LogicType_DeltaEquals]: this.renderNumericInput.bind(this),
        [LogicType_DeltaPercentageGreaterEquals]: this.renderNumericInput.bind(this),
        [LogicType_DeltaPercentageLesserEquals]: this.renderNumericInput.bind(this),
        [LogicType_DeltaPercentageLesserThan]: this.renderNumericInput.bind(this),
        [LogicType_DeltaPercentageGreaterThan]: this.renderNumericInput.bind(this),
        [LogicType_DeltaPercentageEquals]: this.renderNumericInput.bind(this),
        [LogicType_DeltaIn]: this.renderNumericInput.bind(this),
        [LogicType_DeltaPercentageIn]: this.renderNumericInput.bind(this),
        [LogicType_LessThan]: this.renderNumericInput.bind(this),
        [LogicType_GreaterOrEqual]: this.renderNumericInput.bind(this),
        [LogicType_GreaterThan]: this.renderNumericInput.bind(this),
        [LogicType_Exists]: () => _jsx(_Fragment, {}),
        [LogicType_NotExists]: () => _jsx(_Fragment, {}),
        [LogicType_IsFalse]: () => _jsx(_Fragment, {}),
        [LogicType_IsTrue]: () => _jsx(_Fragment, {}),
        [LogicType_Delta]: () => _jsx(_Fragment, {}),
        [LogicType_DeltaPercentage]: () => _jsx(_Fragment, {}),
        [LogicType_IsChiefComplaint]: () => _jsx(_Fragment, {}),
    };
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.mappers ??= {
            variableMap: ModuleFE_Variable.cache.arrayToMap((_var) => _var._id),
            valueMap: ModuleFE_Value.cache.arrayToMap((_var) => _var._id),
            expressionMap: ModuleFE_Expression.cache.arrayToMap((_var) => _var._id),
        };
        return state;
    }
    filterCaseByType = (item) => {
        const leftHand = this.props.leftHand;
        if (!leftHand)
            return true;
        const variable = ModuleFE_Variable.cache.unique(leftHand.id);
        const expression = ModuleFE_Expression.cache.unique(leftHand.id);
        if (!variable && !expression && leftHand.type !== 'atom')
            return false;
        if (leftHand.type === 'expression') {
            return getExpressionQueryFilter(leftHand.id, item, this.state.mappers, this.props.operatorsToFilter);
        }
        if (leftHand.type === 'atom') {
            if (!this.props.atom)
                return true;
            return getAtomQueryFilter(this.props.atom, item, this.state.mappers, this.props.operatorsToFilter);
        }
        return getValueQueryFilter(leftHand, item, this.state.mappers, this.props.operatorsToFilter);
    };
    /**
     * Retrieves relevant values for a given case right hand values in context with left and right hand items.
     * @param editable - The editable item of the right-hand array.
     * @returns An array of relevant values, excluding those already present in the right hand array.
     * @throws {MUSTNeverHappenException} If no value or variable is found.
     */
    getRelevantValues(editable) {
        const leftHandItem = this.props.leftHand;
        // Determine the variable ID based on left-hand item's type and properties.
        const variableId = this.resolveVariableId();
        const variable = ModuleFE_Variable.cache.unique(variableId);
        // Choose the appropriate value ID based on the left-hand item's type and the variable's existence.
        const valueId = leftHandItem?.type === 'expression' ||
            (leftHandItem?.type === 'atom' && !variable)
            ? valueID_YesNo
            : variable?.valueId;
        const value = ModuleFE_Value.cache.unique(valueId);
        if (!value) {
            throw new MUSTNeverHappenException(`No value or variable found for variableId: ${variableId}`);
        }
        // Filter out the relevant values that are not already part of the editable item.
        // @ts-ignore
        return filterRelevantValues(value).filter(val => !editable.item.includes(val));
    }
    /**
     * Resolve the right variable id to use in the value dropdown from all cases
     * In case of sub-term resolve it from the passed atom prop if the logic is self
     * in all other cases resolve it right from this atom left hand
     */
    resolveVariableId = () => {
        const leftHandItem = this.props.leftHand;
        const atomItem = this.props.atom;
        // This condition ensure that we're in a sub-term context and we're using self logic
        if (atomItem && atomItem.cases[0].caseOperator === LogicType_Self)
            return atomItem.leftHand?.id;
        return leftHandItem.propertyId ?? leftHandItem?.id;
    };
    getCaret = () => {
        return !this.props.viewMode ? DropDown_DefaultCaret : undefined;
    };
    resolveRangeFromValue = (valueId) => {
        const value = ModuleFE_Value.cache.unique(valueId);
        if (!value)
            throw new BadImplementationException(`value with id ${valueId} doesn't exists`);
        return value.data?.scope;
    };
    setDeltaTypeOperator = async (deltaType) => {
        const baseDeltaOp = getBaseDeltaOperator(this.state.editable.get('caseOperator'));
        const deltaTypeOperator = AllDeltaLogic.find(op => op === `${baseDeltaOp}${deltaType}`);
        if (deltaType === LogicType_Self)
            return this.state.editable.updateObj({
                caseOperator: baseDeltaOp,
                valueType: 'numeric',
                rightHand: []
            });
        if (!deltaTypeOperator)
            throw new MUSTNeverHappenException(`Invalid delta operators ${baseDeltaOp}${deltaType}`);
        await this.state.editable.updateObj({
            caseOperator: deltaTypeOperator,
            valueType: undefined
        });
    };
    // ######################### Render #########################
    renderBody = () => {
        return _jsxs(_Fragment, { children: [_jsxs(LL_H_T, { style: { gap: 10 }, children: [this.renderOperatorDropdown(), this.renderDeltaTypeDropdown(), this.renderRightHand()] }), _jsxs(LL_H_C, { className: "match_parent", style: { gap: 10, alignItems: 'flex-start', justifyContent: 'flex-end' }, children: [this.renderValueInput(), !this.props.viewMode &&
                            _jsx(LL_H_C, { onClick: () => this.props.deleteCase(), className: 'delete-wrapper match_height', children: _jsx(ICONS.x.component, { className: 'expression-editor__close-icon' }) })] })] });
    };
    renderDeltaTypeDropdown = () => {
        const caseOperator = this.state.editable.get('caseOperator');
        if (!AllDeltaLogic.includes(caseOperator))
            return '';
        return _jsx(DropDown_DeltaTypes.selectable
        //this is very arabic, I dislike that we need to find a better solution to apply error handling on selectable stuff
        , { 
            //this is very arabic, I dislike that we need to find a better solution to apply error handling on selectable stuff
            error: exists(this.state.editable.hasError('caseOperator')) ? {
                message: this.state.editable.hasError('caseOperator'),
                level: 'error'
            } : undefined, onSelected: this.setDeltaTypeOperator, showErrorTooltip: true, queryFilter: op => !this.props.operatorsToFilter?.includes(op), selected: DeltaTypes.find(type => caseOperator.endsWith(type)) ?? LogicType_Self });
    };
    renderVariableValueDropdown(editable) {
        const unusedValues = this.getRelevantValues(editable);
        const DropDown_RightHandValues = this.getRightHandValuesDropdown(unusedValues);
        return _jsx(LL_V_L, { className: 'expression-sublist', children: DropDown_RightHandValues({
                editable: this.state.editable,
                prop: 'rightHand',
                disabled: this.props.viewMode,
                showErrorTooltip: true,
                onSelected: async (value) => {
                    if (value)
                        await this.state.editable.update('rightHand', [value]);
                }
            }) });
    }
    getRightHandValuesDropdown = (unusedValues) => {
        const adapter = SimpleListAdapter(unusedValues, item => {
            const selected = Array.isArray(item.item) ? item.item[0] : item.item;
            if (!selected)
                return _jsx("div", { className: 'ts-dropdown__placeholder', children: "Pick A Value" });
            const value = ModuleFE_Value.cache.unique(selected);
            if (!value)
                throw new MUSTNeverHappenException(`value with id ${selected} is missing`);
            return _jsx(_Fragment, { children: resolveValueDisplay(value) });
        });
        const mandatoryProps_ValueDropdown = {
            adapter: adapter,
            caret: this.getCaret()
        };
        return TS_DropDown.prepareEditable(mandatoryProps_ValueDropdown);
    };
    renderFactorInput() {
        const editableFactor = this.state.editable.editProp('factor', { upper: 1, lower: 1 });
        return _jsxs(LL_H_C, { className: 'case-editor__factor-container', children: [_jsx(ICONS.x.component, {}), _jsx("div", { className: 'factor-label', children: "Upper:" }), _jsx(DefaultEditor_InputNumeric, { editable: editableFactor, placeholder: 'Upper Factor', prop: 'upper', disabled: this.props.viewMode, onChange: value => {
                        if (!value) {
                            return editableFactor.update('upper', 1);
                        }
                        return editableFactor.update('upper', value);
                    }, showErrorTooltip: true }), _jsx("div", { className: 'factor-label', children: "Lower:" }), _jsx(DefaultEditor_InputNumeric, { editable: editableFactor, placeholder: 'Lower Factor', prop: 'lower', disabled: this.props.viewMode, onChange: value => {
                        if (!value) {
                            return editableFactor.update('lower', 1);
                        }
                        return editableFactor.update('lower', value);
                    }, showErrorTooltip: true })] });
    }
    renderNumericInput(editable) {
        if (this.state.editable.get('caseOperator') === LogicType_In && getLeftHandType(this.props.leftHand, this.state.mappers, this.props.atom) === 'time')
            return this.renderVariableValueDropdown(this.state.editable.editProp('rightHand', []));
        if (!ModuleFE_Expression.isRightHand.range(this.state.editable))
            throw new BadImplementationException(`case operator ${this.state.editable.get('caseOperator')} doesn't fit renderer`);
        // First check if the value already exists and classify if it's range value id or a range tuple
        let valueRange;
        if (editable.item.length === 1) {
            valueRange = this.resolveRangeFromValue(editable.get(0));
        }
        return _jsxs(LL_H_C, { className: 'expression-sublist', children: [this.renderDbRangesDropDown(editable), _jsx(QRangeInputV3, { editable: this.state.editable, prop: 'rightHand', value: valueRange, placeholder: 'Value', disabled: this.props.viewMode, showErrorTooltip: true })] });
    }
    renderDbRangesDropDown = (editable) => {
        const leftHand = this.props.leftHand;
        // Expression doesn't have a value related to it so no need for the check.
        let variable;
        let variableVal;
        if (leftHand?.type !== 'expression' && !variableVal) {
            const varId = this.resolveVariableId();
            variable = ModuleFE_Variable.cache.unique(varId);
            variableVal = ModuleFE_Value.cache.unique(variable?.valueId);
        }
        if (!variableVal || variableVal.type === valueType_StandardRange || this.state.editable.get('caseOperator') !== LogicType_In)
            return '';
        return _jsx(DropDown_Value.selectable, { placeholder: 'Pick Range (Optional)', onSelected: async (val) => {
                if (val)
                    await this.state.editable.update('rightHand', [val._id]);
                else
                    await this.state.editable.update('rightHand', []);
            }, selected: editable.item[0], caret: this.getCaret(), disabled: this.props.viewMode, showErrorTooltip: true, queryFilter: (val) => filterRelevantValues(variableVal).includes(val._id) });
    };
    renderInSetDropdownList(editable) {
        const unusedValues = this.getRelevantValues(editable);
        const adapter = SimpleListAdapter(unusedValues, (item) => {
            const value = ModuleFE_Value.cache.unique(item.item);
            if (!value || Array.isArray(item.item))
                return _jsx(_Fragment, {});
            return _jsx(_Fragment, { children: resolveValueDisplay(value) });
        });
        const DropDown_InSetMultiselect = TS_DropDown.prepareSelectable({
            adapter: adapter,
            caret: this.getCaret(),
            placeholder: 'Select in-set values',
        });
        return _jsx(LL_V_L, { className: 'expression-sublist', children: _jsx(TS_MultiSelect_V2, { itemRenderer: (id, onDelete) => {
                    let label;
                    if (typeof id !== 'string')
                        label = `Incompatible type for id: ${id} is of type ${typeof id}`;
                    else {
                        const value = ModuleFE_Value.cache.unique(id);
                        if (!value)
                            throw new MUSTNeverHappenException(`Could not get value for id ${id}`);
                        label = resolveValueDisplay(value);
                    }
                    return _jsxs(_Fragment, { children: [_jsx("div", { className: 'value-label', children: label }), !this.props.viewMode &&
                                _jsx(ICONS.x.component, { onClick: onDelete })] });
                }, selectionRenderer: selector => {
                    return DropDown_InSetMultiselect({
                        disabled: this.props.viewMode,
                        showErrorTooltip: true,
                        queryFilter: item => !selector.existingItems.includes(item._id),
                        onSelected: (value) => {
                            if (value)
                                selector.onSelected(value);
                        },
                        error: exists(this.state.editable.hasError('rightHand')) ? {
                            message: this.state.editable.hasError('rightHand'),
                            level: 'error'
                        } : undefined
                    });
                }, editable: this.state.editable, prop: 'rightHand' }) });
    }
    /**
     * The equality operator can be used for numeric and enumerated values
     * this function will behave as an index making sure what's the value type of our left hand and conditionally render
     * the right component for the right hand
     * @param editable
     * @private
     */
    renderEqualityByType(editable) {
        const leftHand = this.props.leftHand;
        if (!leftHand)
            return '';
        //If variable or expression not found return nothing
        const leftHandId = leftHand.type === 'atom' ? this.props.atom?.leftHand?.id : leftHand.id;
        const variable = ModuleFE_Variable.cache.unique(leftHandId);
        const expression = ModuleFE_Expression.cache.unique(leftHandId);
        if (!variable && !expression)
            return '';
        const type = getLeftHandType(leftHand, this.state.mappers, this.props.atom);
        if (type === ExpressionOutput_Numeric || type === valueType_StandardRange || type === valueType_Range)
            return this.renderNumericInput(editable);
        else
            return this.renderVariableValueDropdown(editable);
    }
    renderOperatorDropdown = () => {
        if (!validateLeftHandBaseExists(this.props.leftHand) && this.props.leftHand)
            return;
        const adapter = SimpleListAdapter(AllLogics.filter(logic => this.filterCaseByType(logic)), item => _jsx(_Fragment, { children: item.item }));
        const DropDown_CaseOperators = TS_DropDown.prepare({
            className: 'operator-dropdown',
            adapter: adapter,
            placeholder: 'Pick Operator',
            caret: this.getCaret()
        });
        const caseOperator = this.state.editable.get('caseOperator');
        const selectedOperator = getBaseDeltaOperator(caseOperator) ?? caseOperator;
        return DropDown_CaseOperators.selectable({
            showErrorTooltip: true,
            disabled: !this.props.leftHand || this.props.viewMode || (this.props.disableOperatorSelection
                && AllDeltaLogic.includes(caseOperator)),
            selected: selectedOperator,
            onSelected: async (value) => {
                const changes = {};
                if (value) {
                    changes.caseOperator = value;
                    changes.factor = undefined;
                    if (EmptyRightHandOperators.includes(value))
                        changes.rightHand = [];
                    if (SelfOperators.includes(value)) {
                        changes.valueType = resolveValueType(this.props.leftHand, this.state.mappers);
                    }
                    else if (exists(this.state.editable.get('valueType')))
                        changes.valueType = undefined;
                    await this.state.editable.updateObj(changes);
                }
            }
        });
    };
    renderRightHand = () => {
        const caseItem = this.state.editable.item;
        if (!caseItem.caseOperator || !validateLeftHandBaseExists(this.props.leftHand))
            return '';
        const editableRightHand = this.state.editable.editProp('rightHand', []);
        const Renderer = this.Renderers[caseItem.caseOperator]?.(editableRightHand);
        if (!Renderer)
            return 'to be created';
        return _jsx(_Fragment, { children: Renderer });
    };
    renderValueInput = () => {
        const editableCase = this.state.editable;
        return _jsxs(LL_H_C, { className: 'condition-value', style: { display: !this.props.withValue ? 'none' : 'flex' }, children: [_jsx("div", { className: 'divider' }), _jsx(QRangeInputV3, { editable: editableCase, prop: 'value', disabled: this.props.viewMode, className: 'term-value-input', placeholder: 'Value', shouldReset: true, showErrorTooltip: true })] });
    };
    render() {
        return _jsx(_Fragment, { children: this.renderBody() });
    }
}
//# sourceMappingURL=Editor_Case.js.map